import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

const pathBase = API_ROUTES.SETTINGS.PANEL.MANAGER

export function addManagerPanel(data) {
    return apiHelper({ method: "post", path: pathBase.CREATE, data })
}

export function editManagerPanel(data) {
    return apiHelper({ method: "post", path: pathBase.EDIT, data })
}

export function deleteManagerPanel(panelId) {
    return apiHelper({ method: "delete", path: pathBase.DELETE, data: { panelId } })
}

export function getManagerPanelList() {
    return apiHelper({ method: "get", path: pathBase.GET_ALL })
}
